import { all, call, throttle, put, getContext } from 'redux-saga/effects';
import { SearchActionTypes } from '../../../enums/ActionEnums';
import SearchAPI from '../../../api/search/SearchAPI';
import { searchActions } from '../actions/SearchActions.creators';
export function* fetchWithoutProductsSearch(action) {
    try {
        const { defaultRequestParams, servicesEndpoint, activeEnvironment, elasticsearchIndex } = yield getContext('aemConfiguration');
        const searchSuggestions = yield call(SearchAPI.searchSuggestions, servicesEndpoint, defaultRequestParams, action.payload);
        const allSuggestions = {
            searchContent: null,
            searchSuggestions: searchSuggestions,
        };
        const contentSearch = yield call(SearchAPI.searchContentSuggestion, servicesEndpoint, `${activeEnvironment}_${elasticsearchIndex}`, action.payload);
        if (contentSearch && contentSearch.content) {
            allSuggestions.searchContent = contentSearch.content;
        }
        yield put(searchActions.createFindAction(allSuggestions));
    }
    catch (_a) { }
}
export function* loadFetchWithoutProductsSaga() {
    yield throttle(500, SearchActionTypes.FETCH_WITHOUT_PRODUCTS, fetchWithoutProductsSearch);
}
export default function* SearchSaga() {
    yield all([loadFetchWithoutProductsSaga()]);
}
